/**
 * advancedSettingsMap represents a map for information on advanced settings in shared mailbox
*/
const advancedSettingsMap = {
    'auto_assign_on_reply': {
        primaryText: 'Auto-assign unassigned conversations to responder',
        secondaryText: 'Automatically assign an unassigned conversation to the member who makes the first, next or periodic response.',
        tag: {
            title: 'Hiver only',
            tooltip: 'Only applicable for responses sent from Hiver web and mobile.'
        }
    },
    'notify_new_email': {
        primaryText: 'New conversations',
        secondaryText: 'Notify everyone when a new conversation arrives in the shared mailbox',
    },
    'send_as_email': {
        primaryText: 'Auto select shared mailbox email on Compose',
        secondaryText: 'Currently selected shared mailbox email id will be chosen by default as sender when new emails are composed'
    },
    'remove_inbox_on_reassignment': {
        primaryText: 'Remove conversation from inbox on re-assignment',
        secondaryText: 'When a conversation is reassigned or unassigned, remove it from the previous assignee\'s inbox'
    },
    'csat': {
        primaryText: 'Customer Satisfaction (CSAT)',
        secondaryText: 'Ask customer feedback and rating on suppport they received'
    },
    'removed_conversations': {
        primaryText: 'Removed conversations log',
        secondaryText: 'Setup an email service to periodically receive a log of conversations that were removed from this shared mailbox.'
    }
}


export const snackbarMessages = {
    'auto_assign_on_reply': {
        success: (smName='Support mailbox') =>  `Enabled for ${smName}`,
        failed: (smName='Support mailbox') =>  `Disabled for ${smName}`
    },
    'approvals': {
        success: (smName='Support mailbox') =>  `Approvals enabled for ${smName}`,
        failed: (smName='Support mailbox') =>  `Approvals disabled for ${smName}`
    }
}
/**
 * @param  {string} id - setting id
 * @returns              setting object for given setting id
 */
export const getLabelForSetting = (id) => advancedSettingsMap[id];

/**
 * jss compatible style object for settingsContainer Component
 */
export const style = {
    body: {
        height: '70vh !important',
        overflow: 'auto',
        paddingRight: '20px'
    },
    nameForm: {
        marginTop: 11
    },
    subText: {
        marginTop: '6px'
    },
    formListContainer: {
        marginTop: 18,
        width: '70%',
        paddingBottom: 5,
        '@media all and (max-width: 1000px)': {
            width: '100%'
        }
    },
    toggleList: {
        marginTop: 45,
        paddingBottom: 40
    },
    listItem: {
        margin: '16px 0',
        padding: '10px 0'
    },
    customInput60: {
        width: '76% !important'
    },
    customInput80: {
        width: '85.35% !important'
    },
    noBusinessHourList: {
        marginTop: '10px'
    },
    draftEdit: {
        marginBottom: '50px',
        color: '#688899',
        display: 'inline-block',
        paddingLeft: '5px',
        '& a': {
            textDecoration: 'none',
            color: '#0090fff5',
            paddingLeft: '2px'
        },
        '& a:hover': {
            textDecoration: 'underline',
            color: '#0090fff5'
        }
    },
    busineessHourName: {
        marginTop: '48px'
    },
    businessHourDropdown: {
    },
    linkedSla: {
        backgroundColor: '#a0d6f940',
        paddingTop: '14px',
        paddingBottom: '5px',
        color: '#688899',
        marginTop: 10,
        '& .flexbox': {
            marginRight: 11,
            marginTop:8,
            marginBottom:5,
            marginLeft: 39
        }
    },
    draft: {
        marginLeft: '15px',
        '& span': {
            paddingLeft: '5px',
            paddingRight: '5px'
        }
    },
    slaLabel: {
        backgroundColor: '#b8d3dfb3',
        padding: '5px',
        marginLeft: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '150px',
        display: 'inline-block'

    },
    remaingSlalink: {
        color: '#0074e4',
        marginLeft: '8px',
        cursor: 'pointer',
        padding: 5,
        display: 'inline-block',
        overflow: 'hidden',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
}
